module.exports = __webpack_public_path__ + "static/media/stream-unavailable.528ed766.svg";